// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"622":"4992cbca","1373":"2cd70575","5587":"166c82eb","6243":"166c82eb","7045":"2bc6e047"}[chunkId] + ".chunk.css";
};